import React from "react";
import { Link } from "react-router-dom";

export default function GamePrice() {
  return (
    <section className="game-price ptb-120">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6">
            <div className="section-title text-center mb-5">
              <h2 className="text-white mb-4">Check Out Our Hosting Suite</h2>
              <p className="m-0 text-off-white">
                There are many variations of passages of Lorem Ipsum available,
                but the majority randomised words which don't look even slightly
                believable.
              </p>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-4 col-md-6 col-sm-12">
            <div className="single-game-price mb-4 mb-lg-0">
              <div className="d-flex align-items-center">
                <div className="price-icon me-3 flex-shrink-0">
                  <img src="assets/img/wordpress.png" alt="icon" />
                </div>
                <div>
                  <h5 className="text-white mb-1">WordPress Hosting</h5>
                  <span className="text-off-white">Starting at $2.99/mo </span>
                </div>
              </div>
              <p className="py-3 m-0">
                Whether hosting community forums, an online store, or even a
                blog, this platform is built to meet and surpass your every
                regard.
              </p>
              <ul className="list-unstyled">
                <li className="pb-2">
                  <i className="far fa-check fa-2xs me-2"></i>
                  <span>50+ Pro Widgets</span>
                </li>
                <li className="pb-2">
                  <i className="far fa-check fa-2xs me-2"></i>
                  <span>300+ Pro Templates</span>
                </li>
                <li className="pb-2">
                  <i className="far fa-check fa-2xs me-2"></i>
                  <span>Theme Builder</span>
                </li>
                <li className="pb-2">
                  <i className="far fa-check fa-2xs me-2"></i>
                  <span>Woo Commers Builder</span>
                </li>
                <li className="pb-2">
                  <i className="far fa-check fa-2xs me-2"></i>
                  <span>Support for 1 Year</span>
                </li>
                <li className="pb-2">
                  <i className="far fa-check fa-2xs me-2"></i>
                  <span>Updates for 1 Years</span>
                </li>
                <li className="pb-2">
                  <i className="far fa-check fa-2xs me-2"></i>
                  <span>WordPress Staging Tool</span>
                </li>
                <li className="pb-2">
                  <i className="far fa-check fa-2xs me-2"></i>
                  <span>Multiple Data Centers</span>
                </li>
              </ul>
              <div className="game-price-btn">
                <Link to="/contact-us" className="mt-4">
                  Check More Plans
                </Link>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12">
            <div className="single-game-price mb-4 mb-lg-0 active">
              <div className="d-flex align-items-center">
                <div className="price-icon me-3 flex-shrink-0">
                  <img src="assets/img/cloud.png" alt="icon" />
                </div>
                <div>
                  <h5 className="text-white mb-1">Shared Hosting</h5>
                  <span className="text-off-white">Starting at $2.99/mo </span>
                </div>
              </div>
              <p className="py-3 m-0">
                Whether hosting community forums, an online store, or even a
                blog, this platform is built to meet and surpass your every
                regard.
              </p>
              <ul className="list-unstyled">
                <li className="pb-2">
                  <i className="far fa-check fa-2xs me-2"></i>
                  <span>50+ Pro Widgets</span>
                </li>
                <li className="pb-2">
                  <i className="far fa-check fa-2xs me-2"></i>
                  <span>300+ Pro Templates</span>
                </li>
                <li className="pb-2">
                  <i className="far fa-check fa-2xs me-2"></i>
                  <span>Theme Builder</span>
                </li>
                <li className="pb-2">
                  <i className="far fa-check fa-2xs me-2"></i>
                  <span>Woo Commers Builder</span>
                </li>
                <li className="pb-2">
                  <i className="far fa-check fa-2xs me-2"></i>
                  <span>Support for 1 Year</span>
                </li>
                <li className="pb-2">
                  <i className="far fa-check fa-2xs me-2"></i>
                  <span>Updates for 1 Years</span>
                </li>
                <li className="pb-2">
                  <i className="far fa-check fa-2xs me-2"></i>
                  <span>WordPress Staging Tool</span>
                </li>
                <li className="pb-2">
                  <i className="far fa-check fa-2xs me-2"></i>
                  <span>Multiple Data Centers</span>
                </li>
              </ul>
              <div className="game-price-btn">
                <Link to="/contact-us" className="mt-4">
                  Check More Plans
                </Link>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12">
            <div className="single-game-price">
              <div className="d-flex align-items-center">
                <div className="price-icon me-3 flex-shrink-0">
                  <img src="assets/img/globe.png" alt="icon" />
                </div>
                <div>
                  <h5 className="text-white mb-1">VPS Hosting</h5>
                  <span className="text-off-white">Starting at $2.99/mo </span>
                </div>
              </div>
              <p className="py-3 m-0">
                Whether hosting community forums, an online store, or even a
                blog, this platform is built to meet and surpass your every
                regard.
              </p>
              <ul className="list-unstyled">
                <li className="pb-2">
                  <i className="far fa-check fa-2xs me-2"></i>
                  <span>50+ Pro Widgets</span>
                </li>
                <li className="pb-2">
                  <i className="far fa-check fa-2xs me-2"></i>
                  <span>300+ Pro Templates</span>
                </li>
                <li className="pb-2">
                  <i className="far fa-check fa-2xs me-2"></i>
                  <span>Theme Builder</span>
                </li>
                <li className="pb-2">
                  <i className="far fa-check fa-2xs me-2"></i>
                  <span>Woo Commers Builder</span>
                </li>
                <li className="pb-2">
                  <i className="far fa-check fa-2xs me-2"></i>
                  <span>Support for 1 Year</span>
                </li>
                <li className="pb-2">
                  <i className="far fa-check fa-2xs me-2"></i>
                  <span>Updates for 1 Years</span>
                </li>
                <li className="pb-2">
                  <i className="far fa-check fa-2xs me-2"></i>
                  <span>WordPress Staging Tool</span>
                </li>
                <li className="pb-2">
                  <i className="far fa-check fa-2xs me-2"></i>
                  <span>Multiple Data Centers</span>
                </li>
              </ul>
              <div className="game-price-btn">
                <Link to="/contact-us" className="mt-4">
                  Check More Plans
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
